import { ComponentProps } from "react";

import { useNavigation } from "@react-navigation/native";

import { LoginScreenProps } from "./types";
import { Header } from "../../../components";

export default function LoginHeader(props: ComponentProps<typeof Header>) {
  const navigation = useNavigation<LoginScreenProps["navigation"]>();

  return <Header onBackPress={navigation.goBack} {...props} />;
}
